import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthToken, getRefreshToken } from "../../config/services/ApiServices";
export const fetchToken = createAsyncThunk(
  'Token/fetch',
  async (
    { username, password }: { username: string; password: string },
    { rejectWithValue }
  ) => {
    try {
      const { accessToken, refreshToken, expiresIn } = await getAuthToken({ username, password });

      return { accessToken, refreshToken, expiresIn };
    } catch (error: any) {
      
      let errorMessage = 'Login failed';
      
      if (error.response) {
        const responseData = error.response.data;
        
        if (typeof responseData === 'string') {
          errorMessage = responseData;
        } else if (responseData) {
          errorMessage = responseData.message || 
                        responseData.error || 
                        responseData.data?.message ||
                        responseData.data?.error ||
                        'Login failed';
        }
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      console.log("LoginThunk - final errorMessage:", errorMessage);
      
      return rejectWithValue(errorMessage);
    }
  }
);


export const fetchRefreshToken = createAsyncThunk('RefreshToken/fetch', async ({ refreshtoken, accessToken }: { refreshtoken: any, accessToken: any }) => {
  const response = await getRefreshToken({ refreshtoken, accessToken });
  return response;
})
